var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { COMMISSIONS_ERROR_ACTION_TYPE, COMMISSIONS_FETCH_BY_STAFF_MEMBER_START_ACTION_TYPE, COMMISSIONS_FETCH_BY_STAFF_MEMBER_SUCCESS_ACTION_TYPE, COMMISSIONS_FETCH_START_ACTION_TYPE, COMMISSIONS_FETCH_SUCCESS_ACTION_TYPE, COMMISSIONS_GET_REPORT_START_ACTION_TYPE, COMMISSIONS_GET_REPORT_SUCCESS_ACTION_TYPE, COMMISSIONS_GET_START_ACTION_TYPE, COMMISSIONS_GET_SUCCESS_ACTION_TYPE, COMMISSIONS_RESET_ACTION_TYPE, COMMISSIONS_SAVE_START_ACTION_TYPE, COMMISSIONS_SAVE_SUCCESS_ACTION_TYPE, } from '../action/CommissionsActionsTypes';
import { sortCommissionPlans } from '../action/CommissionsConverter';
import { CommissionsStatus } from './CommissionsState';
var initialState = {
    commissionPlans: [],
    staffMemberCommissionPlans: [],
    commissionPlan: undefined,
    savedCommissionPlan: undefined,
    status: CommissionsStatus.Initial,
    report: undefined,
    requestTokens: {
        report: '',
    }
};
export var commissionsReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case COMMISSIONS_FETCH_START_ACTION_TYPE:
            return __assign(__assign({}, state), { commissionPlans: [], status: CommissionsStatus.Fetching });
        case COMMISSIONS_FETCH_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { commissionPlans: sortCommissionPlans(action.payload.commissionPlans), status: CommissionsStatus.FetchSuccess });
        case COMMISSIONS_FETCH_BY_STAFF_MEMBER_START_ACTION_TYPE:
            return __assign(__assign({}, state), { staffMemberCommissionPlans: [], status: CommissionsStatus.FetchingByStaffMember });
        case COMMISSIONS_FETCH_BY_STAFF_MEMBER_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { staffMemberCommissionPlans: sortCommissionPlans(action.payload.commissionPlans), status: CommissionsStatus.FetchByStaffMemberSuccess });
        case COMMISSIONS_GET_START_ACTION_TYPE:
            return __assign(__assign({}, state), { commissionPlan: undefined, status: CommissionsStatus.Getting });
        case COMMISSIONS_GET_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { commissionPlans: sortCommissionPlans(state.commissionPlans.map(function (cp) {
                    return cp.id === action.payload.commissionPlan.id ? action.payload.commissionPlan : cp;
                })), staffMemberCommissionPlans: sortCommissionPlans(state.staffMemberCommissionPlans.map(function (cp) {
                    return cp.id === action.payload.commissionPlan.id ? action.payload.commissionPlan : cp;
                })), commissionPlan: action.payload.commissionPlan, status: CommissionsStatus.GetSuccess });
        case COMMISSIONS_SAVE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { savedCommissionPlan: undefined, status: CommissionsStatus.Saving });
        case COMMISSIONS_SAVE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { commissionPlans: sortCommissionPlans(state.commissionPlans.map(function (cp) {
                    return cp.uuid === action.payload.commissionPlan.uuid ? action.payload.commissionPlan : cp;
                })), staffMemberCommissionPlans: sortCommissionPlans(state.staffMemberCommissionPlans.map(function (cp) {
                    return cp.uuid === action.payload.commissionPlan.uuid ? action.payload.commissionPlan : cp;
                })), commissionPlan: ((_a = state.commissionPlan) === null || _a === void 0 ? void 0 : _a.uuid) === action.payload.commissionPlan.uuid
                    ? action.payload.commissionPlan
                    : state.commissionPlan, savedCommissionPlan: action.payload.commissionPlan, status: CommissionsStatus.SaveSuccess });
        case COMMISSIONS_GET_REPORT_START_ACTION_TYPE:
            return __assign(__assign({}, state), { requestTokens: __assign(__assign({}, state.requestTokens), { report: action.payload.requestToken }), status: CommissionsStatus.GettingReport });
        case COMMISSIONS_GET_REPORT_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { report: action.payload.report, status: CommissionsStatus.GetReportSuccess });
        case COMMISSIONS_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: CommissionsStatus.Error });
        case COMMISSIONS_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        default:
            return state;
    }
};
export default commissionsReducer;
